// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-query-assistant {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  background: #f5f7fa;
}

.assistant-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.assistant-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-icon {
  font-size: 32px;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.btn-secondary {
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.health-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.status-dot.healthy {
  background: #4caf50;
}

.status-dot.degraded {
  background: #ff9800;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

.ai-query-assistant .alert {
  margin: 15px 30px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
}

.ai-query-assistant .alert-warning {
  background: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
}

.assistant-container {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  margin: 0 20px 20px;
  gap: 20px;
}

.history-panel {
  width: 300px;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
}

.history-panel h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-item {
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.history-item:hover {
  background: #e9ecef;
  transform: translateX(2px);
}

.history-item.success {
  border-left-color: #4caf50;
}

.history-item.error {
  border-left-color: #f44336;
}

.history-query {
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
  line-height: 1.4;
}

.history-meta {
  display: flex;
  gap: 8px;
  font-size: 11px;
  color: #666;
}

.history-status {
  font-weight: bold;
}

.history-status.success {
  color: #4caf50;
}

.history-status.error {
  color: #f44336;
}

.history-intent {
  background: #e3f2fd;
  padding: 2px 6px;
  border-radius: 3px;
  color: #1976d2;
}

.empty-history {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}

.conversation-panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.conversation-area {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

.welcome-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 40px;
}

.welcome-icon {
  font-size: 80px;
  margin-bottom: 20px;
}

.welcome-screen h2 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 28px;
}

.welcome-screen > p {
  margin: 0 0 40px 0;
  color: #666;
  font-size: 16px;
}

.sample-queries {
  width: 100%;
  max-width: 700px;
  margin-bottom: 40px;
}

.sample-queries h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 18px;
}

.sample-query-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 20px;
  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
  border: 1px solid #667eea30;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sample-query-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
  border-color: #667eea;
}

.sample-icon {
  font-size: 20px;
}

.sample-text {
  flex: 1 1;
  text-align: left;
  color: #333;
  font-size: 14px;
}

.capabilities {
  width: 100%;
  max-width: 600px;
  text-align: left;
}

.capabilities h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 18px;
}

.capabilities ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.capabilities li {
  padding: 8px 0;
  color: #666;
  font-size: 14px;
}

.message {
  margin-bottom: 20px;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.message-icon {
  font-size: 20px;
}

.message-label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.message-time {
  margin-left: auto;
  font-size: 12px;
  color: #999;
}

.user-message .message-content {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 16px;
  border-radius: 12px 12px 12px 4px;
  max-width: 70%;
  font-size: 14px;
  line-height: 1.5;
}

.agent-message .message-content {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 12px;
  border-left: 4px solid #667eea;
}

.explanation {
  margin-bottom: 15px;
  padding: 12px;
  background: white;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.query-metadata {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.metadata-item {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 13px;
}

.metadata-label {
  color: #666;
  font-weight: 500;
}

.metadata-value {
  color: #333;
  font-weight: 600;
}

.intent-badge {
  background: #e3f2fd;
  padding: 2px 8px;
  border-radius: 4px;
  color: #1976d2;
  font-size: 12px;
}

.sql-details {
  margin-bottom: 15px;
  background: white;
  border-radius: 6px;
  overflow: hidden;
}

.sql-details summary {
  padding: 10px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #667eea;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
}

.sql-details summary:hover {
  background: #f0f0f0;
}

.sql-code {
  margin: 0;
  padding: 15px;
  background: #1e1e1e;
  color: #d4d4d4;
  border-radius: 0 0 6px 6px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  overflow-x: auto;
  line-height: 1.5;
}

.results-container {
  background: white;
  border-radius: 6px;
  overflow: hidden;
}

.results-header {
  padding: 10px 12px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
}

.results-table-wrapper {
  overflow-x: auto;
  max-height: 400px;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.results-table thead {
  background: #667eea;
  color: white;
  position: sticky;
  top: 0;
  z-index: 1;
}

.results-table th {
  padding: 10px 12px;
  text-align: left;
  font-weight: 600;
  white-space: nowrap;
}

.results-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #e9ecef;
  color: #333;
}

.results-table tbody tr:hover {
  background: #f8f9fa;
}

.no-results {
  padding: 20px;
  text-align: center;
  color: #666;
  font-size: 14px;
}

.error-content {
  background: #ffebee !important;
  border-left-color: #f44336 !important;
}

.error-icon {
  font-size: 24px;
  margin-bottom: 10px;
}

.error-message {
  color: #c62828;
  font-size: 14px;
  line-height: 1.5;
}

.loading {
  opacity: 0.8;
}

.loading-indicator {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
}

.loading-dots {
  display: flex;
  gap: 4px;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  background: #667eea;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.loading-text {
  color: #666;
  font-size: 13px;
}

.query-input-container {
  display: flex;
  gap: 10px;
  padding: 20px;
  border-top: 1px solid #e9ecef;
  background: white;
}

.query-input {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.query-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.query-input::placeholder {
  color: #999;
}

.btn-submit {
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Scrollbar styling */
.conversation-area::-webkit-scrollbar,
.history-panel::-webkit-scrollbar,
.results-table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.conversation-area::-webkit-scrollbar-track,
.history-panel::-webkit-scrollbar-track,
.results-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.conversation-area::-webkit-scrollbar-thumb,
.history-panel::-webkit-scrollbar-thumb,
.results-table-wrapper::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.conversation-area::-webkit-scrollbar-thumb:hover,
.history-panel::-webkit-scrollbar-thumb:hover,
.results-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`, "",{"version":3,"sources":["webpack://./src/components/AIQueryAssistant.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iEAAiE;EACjE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;;;EAGE,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB","sourcesContent":[".ai-query-assistant {\n  display: flex;\n  flex-direction: column;\n  height: calc(100vh - 100px);\n  background: #f5f7fa;\n}\n\n.assistant-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.assistant-header h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.header-icon {\n  font-size: 32px;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.btn-secondary {\n  padding: 8px 16px;\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-1px);\n}\n\n.health-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n.status-dot.healthy {\n  background: #4caf50;\n}\n\n.status-dot.degraded {\n  background: #ff9800;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.5; }\n}\n\n.ai-query-assistant .alert {\n  margin: 15px 30px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.ai-query-assistant .alert-warning {\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  color: #856404;\n}\n\n.assistant-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  margin: 0 20px 20px;\n  gap: 20px;\n}\n\n.history-panel {\n  width: 300px;\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n}\n\n.history-panel h3 {\n  margin: 0 0 15px 0;\n  font-size: 16px;\n  color: #333;\n}\n\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.history-item {\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-left: 3px solid transparent;\n}\n\n.history-item:hover {\n  background: #e9ecef;\n  transform: translateX(2px);\n}\n\n.history-item.success {\n  border-left-color: #4caf50;\n}\n\n.history-item.error {\n  border-left-color: #f44336;\n}\n\n.history-query {\n  font-size: 13px;\n  color: #333;\n  margin-bottom: 6px;\n  line-height: 1.4;\n}\n\n.history-meta {\n  display: flex;\n  gap: 8px;\n  font-size: 11px;\n  color: #666;\n}\n\n.history-status {\n  font-weight: bold;\n}\n\n.history-status.success {\n  color: #4caf50;\n}\n\n.history-status.error {\n  color: #f44336;\n}\n\n.history-intent {\n  background: #e3f2fd;\n  padding: 2px 6px;\n  border-radius: 3px;\n  color: #1976d2;\n}\n\n.empty-history {\n  text-align: center;\n  padding: 20px;\n  color: #999;\n  font-size: 14px;\n}\n\n.conversation-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.conversation-area {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.welcome-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n  padding: 40px;\n}\n\n.welcome-icon {\n  font-size: 80px;\n  margin-bottom: 20px;\n}\n\n.welcome-screen h2 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 28px;\n}\n\n.welcome-screen > p {\n  margin: 0 0 40px 0;\n  color: #666;\n  font-size: 16px;\n}\n\n.sample-queries {\n  width: 100%;\n  max-width: 700px;\n  margin-bottom: 40px;\n}\n\n.sample-queries h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.sample-query-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 15px 20px;\n  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);\n  border: 1px solid #667eea30;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.sample-query-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\n  border-color: #667eea;\n}\n\n.sample-icon {\n  font-size: 20px;\n}\n\n.sample-text {\n  flex: 1;\n  text-align: left;\n  color: #333;\n  font-size: 14px;\n}\n\n.capabilities {\n  width: 100%;\n  max-width: 600px;\n  text-align: left;\n}\n\n.capabilities h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.capabilities ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.capabilities li {\n  padding: 8px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.message {\n  margin-bottom: 20px;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.message-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.message-icon {\n  font-size: 20px;\n}\n\n.message-label {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.message-time {\n  margin-left: auto;\n  font-size: 12px;\n  color: #999;\n}\n\n.user-message .message-content {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 12px 16px;\n  border-radius: 12px 12px 12px 4px;\n  max-width: 70%;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.agent-message .message-content {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 12px;\n  border-left: 4px solid #667eea;\n}\n\n.explanation {\n  margin-bottom: 15px;\n  padding: 12px;\n  background: white;\n  border-radius: 6px;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #333;\n}\n\n.query-metadata {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.metadata-item {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  font-size: 13px;\n}\n\n.metadata-label {\n  color: #666;\n  font-weight: 500;\n}\n\n.metadata-value {\n  color: #333;\n  font-weight: 600;\n}\n\n.intent-badge {\n  background: #e3f2fd;\n  padding: 2px 8px;\n  border-radius: 4px;\n  color: #1976d2;\n  font-size: 12px;\n}\n\n.sql-details {\n  margin-bottom: 15px;\n  background: white;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.sql-details summary {\n  padding: 10px 12px;\n  cursor: pointer;\n  font-size: 13px;\n  color: #667eea;\n  font-weight: 500;\n  user-select: none;\n}\n\n.sql-details summary:hover {\n  background: #f0f0f0;\n}\n\n.sql-code {\n  margin: 0;\n  padding: 15px;\n  background: #1e1e1e;\n  color: #d4d4d4;\n  border-radius: 0 0 6px 6px;\n  font-family: 'Courier New', monospace;\n  font-size: 12px;\n  overflow-x: auto;\n  line-height: 1.5;\n}\n\n.results-container {\n  background: white;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.results-header {\n  padding: 10px 12px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n  font-size: 14px;\n}\n\n.results-table-wrapper {\n  overflow-x: auto;\n  max-height: 400px;\n}\n\n.results-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.results-table thead {\n  background: #667eea;\n  color: white;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.results-table th {\n  padding: 10px 12px;\n  text-align: left;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.results-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid #e9ecef;\n  color: #333;\n}\n\n.results-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.no-results {\n  padding: 20px;\n  text-align: center;\n  color: #666;\n  font-size: 14px;\n}\n\n.error-content {\n  background: #ffebee !important;\n  border-left-color: #f44336 !important;\n}\n\n.error-icon {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.error-message {\n  color: #c62828;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.loading {\n  opacity: 0.8;\n}\n\n.loading-indicator {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 0;\n}\n\n.loading-dots {\n  display: flex;\n  gap: 4px;\n}\n\n.loading-dots span {\n  width: 8px;\n  height: 8px;\n  background: #667eea;\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.loading-dots span:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.loading-dots span:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n    opacity: 0.5;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.loading-text {\n  color: #666;\n  font-size: 13px;\n}\n\n.query-input-container {\n  display: flex;\n  gap: 10px;\n  padding: 20px;\n  border-top: 1px solid #e9ecef;\n  background: white;\n}\n\n.query-input {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.query-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.query-input::placeholder {\n  color: #999;\n}\n\n.btn-submit {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn-submit:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Scrollbar styling */\n.conversation-area::-webkit-scrollbar,\n.history-panel::-webkit-scrollbar,\n.results-table-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.conversation-area::-webkit-scrollbar-track,\n.history-panel::-webkit-scrollbar-track,\n.results-table-wrapper::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.conversation-area::-webkit-scrollbar-thumb,\n.history-panel::-webkit-scrollbar-thumb,\n.results-table-wrapper::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.conversation-area::-webkit-scrollbar-thumb:hover,\n.history-panel::-webkit-scrollbar-thumb:hover,\n.results-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
